export default __webpack_public_path__ + "static/media/Much More Color.2486fdda.svg";